import {
  INITIALIZE,
  PRIMNAV_INIT,
  PRIMARY_TAB_ACTIVE,
  PRIMARY_TAB_DEACTIVE,
  PRIMARY_TABS_UPDATE_RECT,
  SUBNAV_INIT,
} from 'app/common/constants/action-types';
import { transformFlyouts } from 'app/desktop/helpers/flyout';

export const INITIAL_STATE = {
  activeTab: null,
  primary: [],
  flyouts: {},
  cards: {},
  loaded: false,
};

const initNavbar = (state, action) => {
  const { navbar } = action.payload || {};

  const { primary, flyouts, couponsSubnavLinks } = navbar || {};
  if (!Array.isArray(primary)) {
    return state;
  }

  const updatedFlyouts =
    primary && flyouts
      ? transformFlyouts(flyouts, primary, couponsSubnavLinks)
      : {};

  return {
    ...state,
    primary,
    flyouts: updatedFlyouts,
    couponsSubnavLinks,
  };
};

const updatePrimaryTabsRect = (state, action) => {
  const { rect } = action;
  const { primary } = state;

  const index = primary.findIndex(primTab => primTab.key === rect.id);
  primary[index] = { ...primary[index], ...rect };

  return {
    ...state,
    primary,
  };
};

function primaryNavReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INITIALIZE:
      return initNavbar(state, action);
    case PRIMARY_TAB_ACTIVE:
      return {
        ...state,
        activeTab: action.tab,
      };
    case PRIMARY_TAB_DEACTIVE:
      return {
        ...state,
        activeTab: null,
      };
    case PRIMARY_TABS_UPDATE_RECT:
      return updatePrimaryTabsRect(state, action);
    case SUBNAV_INIT: {
      const { flyouts, cards, isRedesign } = action || {};
      const { couponsSubnavLinks, primary } = state;
      return {
        ...state,
        loaded: true,
        flyouts: transformFlyouts(
          flyouts,
          primary,
          couponsSubnavLinks,
          isRedesign
        ),
        cards,
      };
    }
    case 'SUBNAV_UPDATE_COUPONS': {
      const { couponsSubnavLinks } = action;
      const { flyouts } = state;
      return {
        ...state,
        flyouts: transformFlyouts(flyouts, couponsSubnavLinks),
        couponsSubnavLinks,
      };
    }
    case PRIMNAV_INIT: {
      const { primary } = action || {};
      return {
        ...state,
        primary,
      };
    }
    default:
      return state;
  }
}

export default primaryNavReducer;
